import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {IFilterPropertyItem} from '@toolify/server/src/services/FilterService/types/IFilterPropertyItem'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {
  isNumberBin,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/NumberPropertyTypeStrategy/numberBin'
import {IGroupGranularityDescriptor} from '@toolify/client/src/modules/databases/utils/groupSortModes'
import {
  useValueTypeStrategy,
} from '@toolify/client/src/modules/databases/strategies/PropertyValueTypeStrategy/composables/useValueTypeStrategy'

export function useNumberPropertyTypeStrategy() {
  const getGroupGranularityDescriptor = (property: IDatabasePropertyResponseInstance): IGroupGranularityDescriptor | null => {
    return useValueTypeStrategy(property.valueType).groupGranularity ?? null
  }

  const buildNumberFilterItem = (group: string, operator: FilterPropertyOperator, value: number): IFilterPropertyItem => ({
    type: FilterItemType.Property,
    id: group,
    subProperty: null,
    operator: {
      type: operator,
    },
    payload: {
      type: FilterPropertyPayloadType.Static,
      value,
    },
    isDisabled: false,
  })

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, _showAllDatabaseGroups: boolean): IFilter => {
    const value = groupItem?.value ?? null
    if(!isNumberBin(value)) {
      return null
    }
    return {
      type: FilterItemType.Group,
      operator: FilterGroupOperator.And,
      items: [
        ...(value.from !== null ? [buildNumberFilterItem(group, FilterPropertyOperator.GreaterThanOrEqual, value.from)] : []),
        ...(value.to !== null ? [buildNumberFilterItem(group, FilterPropertyOperator.LessThan, value.to)] : []),
      ],
    }
  }

  return {
    getGroupFilter,
    getGroupGranularityDescriptor,
  }
}
